import KardexView from "../../components/estoque/KardexView";

export default function KardexEstoque() {
  return <KardexView />;
}
